
    var riot = require('riot')
    import { Submit } from './gb-submit';
riot.tag2('gb-submit', '<yield> <a class="gb-submit">&#128269;</a> </yield>', 'gb-submit.gb-stylish a,[data-is="gb-submit"].gb-stylish a{ padding: 4px; } gb-submit.gb-stylish a:hover,[data-is="gb-submit"].gb-stylish a:hover{ cursor: pointer; }', '', function(opts) {
    this._mixin(Submit);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/submit/gb-submit.tag.html